import React, { useState, useEffect } from "react";
import { Route, useParams, useRouteMatch } from "react-router-dom";

/* Sections */
import LabelSelector from "./Sections/LabelSelector";
import CategorySectionBrand from "./CategorySectionBrand";

/* Helpers */
import { PRODUCT, SLUG } from "helpers/helpers";

import Box from "@mui/material/Box";
import { Helmet } from "react-helmet";
import CarsBrandSelector from "./Sections/Menus/CarsBrandSelector";
import NewCatalogue from "./NewCatalogue";
import TypeOilSelector from "./Oil/TypeOilSelector";
import BrandOilSelector from "./Oil/BrandOilSelector";
import SpecificationOilSelector from "./Oil/SpecificationOilSelector";

export default function CategorySection() {
  const { typeSlug } = useParams();
  const { path } = useRouteMatch();
  const [section, setSection] = useState(null);

  // Obtener los datos iniciales
  useEffect(() => {
    setSection(SLUG[typeSlug]);
  }, [typeSlug]);

  return (
    <>
      <Helmet>
        <title>Afinazone</title>
        <meta name="description" content={PRODUCT[SLUG[typeSlug]]} />
      </Helmet>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          component="div"
          sx={{
            fontSize: { xs: "16px", md: "50px" },
            height: { xs: "100%", md: "30vh" },
            margin: { xs: "10px", md: "0" },
            width: "100%",
          }}
          style={{
            fontColor: "black",
            fontWeight: "700",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "70%",
              fontFamily: "Nunito Sans, sans-serif",
            }}
          >
            {section && PRODUCT[section]}
          </div>
        </Box>
        <div
          style={{
            backgroundColor: "white",
            width: "80%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {(section === 'KAT' || section === 'Cart' || section === 'Enf') &&
            <>
              {/* Ruta base: Selección de marca */}
              <Route exact path={path}>
                <LabelSelector optionSection="car" />
                <CarsBrandSelector />
              </Route>

              {/* Ruta anidada: Selección de modelo */}
              <Route exact path={`${path}/:brand`}>
                <LabelSelector optionSection="model" />
                <CategorySectionBrand />
              </Route>

              <Route exact path={`${path}/:brand/:model/:variant`}>
                <NewCatalogue />
              </Route>
            </>
          }
          {section === 'Ac' &&
            <>
              <Route exact path={path}>
                <LabelSelector optionSection="typeAc" />
                <TypeOilSelector />
              </Route>

              <Route exact path={`${path}/:oilType`}>
                <LabelSelector optionSection="brandAc" />
                <BrandOilSelector />
              </Route>

              <Route exact path={`${path}/:oilType/:brand`}>
                <LabelSelector optionSection="specAc" />
                <SpecificationOilSelector />
              </Route>
            </>
          }
        </div>
      </div >
    </>
  );
}